import { Object3D, Vector3 as ThreeVector3 } from 'three';

export const CAMERA_CONFIG = {
    FOV: 28,
    NEAR: 0.000001,
    FAR: 1e10,

    CUSTOM_NEAR: 20.0,
    FAR_EXTENSION: 10000,
} as const;

export const GIZMO_CONFIG = {
    BASE_SIZE: 0.00002,
    DEFAULT_ZOOM_LEVEL: 15,
} as const;

export const LAYER_CONFIG = {
    SHARED_LAYER_ID: '3d-objects-shared-layer',
    LAYER_ID_PREFIX: '3d-object-',
} as const;

export const LIGHT_DEFAULTS = {
    COLOR: '#ffffff',
    INTENSITY: 1,
    HEMISPHERE_GROUND_COLOR: 0x444444,
    TARGET_DISTANCE_MULTIPLIER: 10,
} as const;

export function getObjectLayerId(externalId: string): string {
    return `${LAYER_CONFIG.LAYER_ID_PREFIX}${externalId}`;
}

Object3D.DEFAULT_UP = new ThreeVector3(0, 0, 1);
